import React from 'react';
import { cn } from '@/lib/utils';
import { CONCEPT_ICONS } from '../utils/concept-icons';
import { SIDEBAR_ACTION_HOVER_GROUP } from '../utils/sidebar-action-hover';

interface ScalingShareIconProps {
  className?: string;
  size?: number;
  hoverGroup?: string;
}

export const ScalingShareIcon: React.FC<ScalingShareIconProps> = ({
  className,
  size,
  hoverGroup = SIDEBAR_ACTION_HOVER_GROUP,
}) => {
  const ShareIcon = CONCEPT_ICONS.share;

  return (
    <ShareIcon
      size={size}
      className={cn(
        'h-4 w-4 shrink-0 transition-transform duration-300',
        `group-hover/${hoverGroup}:scale-110`,
        className,
      )}
    />
  );
};
